import React from 'react'

import * as icons from '../Icons'

const getIconDefinitionFor = (iconName: string) => {
  const ICON_DEFINITIONS: {
    [key: string]: React.ForwardRefExoticComponent<
      React.RefAttributes<SVGSVGElement>
    >
  } = {
    'rectangle-ad': icons.IconRectangleAd,
    lightbulb: icons.IconLightbulb,
    'face-grin-squint-tears': icons.IconFaceGrinSquintTears,
    'circle-question': icons.IconCircleQuestion,
    gift: icons.IconGift,
    briefcase: icons.IconBriefcase,
    'tree-christmas': icons.IconTreeChristmas,
    'cake-candles': icons.IconCakeCandles,
    dumbbell: icons.IconDumbbell,
    rabbit: icons.IconRabbit,
    futbol: icons.IconFutbol,
    mustache: icons.IconMustache,
    'venus-mars': icons.IconVenusMars,
    'face-mask': icons.IconFaceMask,
    'graduation-cap': icons.IconGraduationCap,
    envelope: icons.IconEnvelope,
    ticket: icons.IconTicket,
    'face-laugh-squint': icons.IconFaceLaughSquint,
    megaphone: icons.IconMegaphone,
    sun: icons.IconSun,
    'person-breastfeeding': icons.IconPersonBreastfeeding,
    'baby-carriage': icons.IconBabyCarriage,
    'star-shooting': icons.IconStarShooting,
    'comment-dots': icons.IconCommentDots,
    rocket: icons.IconRocket,
    rainbow: icons.IconRainbow,
    fire: icons.IconFire,
    'hat-santa': icons.IconHatSanta,
    'mobile-screen-button': icons.IconMobileScreenButton,
    'handshake-angle': icons.IconHandshakeAngle,
    clover: icons.IconClover,
    turkey: icons.IconTurkey,
    syringe: icons.IconSyringe,
    heart: icons.IconHeart,
    laptop: icons.IconLaptop,
    'champagne-glasses': icons.IconChampagneGlasses,
    'heart-circle-check': icons.IconHeartCircleCheck,
    'ring-diamond': icons.IconRingDiamond,
    'thumbs-up': icons.IconThumbsUp,
    'face-smile-wink': icons.IconFaceSmileWink,
  }

  return ICON_DEFINITIONS[iconName.slice(3)] || null
}

type IconFromNameProps = {
  name: string
}

const IconFromName = ({ name }: IconFromNameProps): JSX.Element => {
  const Icon = getIconDefinitionFor(name)

  if (!Icon) {
    return null
  }

  return <Icon />
}

export default IconFromName
